export default __webpack_public_path__ + "static/pathway-6-54cec15e5effcdfdf79bc7e68e3c7d66.jpg";